import UserRoleFormat from './user-role';
import CurrencySignFormat from './currency-sign';
import TimeFormat from './time';
import Grade from './grade';
import Age from './age';
import Phone from './phone';
import PhoneUK from './phoneUK';
import currencyShort from './currency-short';
import normalizeConstant from './normalizeConstant';
import TimeFormatAmPm from './timeAmPm';
import PriceFormat from './priceFormat';
import toCapitalize from '@/filters/toCapitalize';
import dateFormat from '@/filters/toCapitalize';

export default {
    UserRoleFormat,
    CurrencySignFormat,
    TimeFormat,
    TimeFormatAmPm,
    Grade,
    Age,
    Phone,
    currencyShort,
    normalizeConstant,
    PriceFormat,
    toCapitalize,
    dateFormat,
    PhoneUK
}


// WEBPACK FOOTER //
// ./src/filters/index.js